import { gqlHost as subscriptionGGLHost } from '@ashn/fitsubscription-react/Support';
import getApiEnvironment from './environmentHelpers/getAPIEnvironments';

const apiEnv = getApiEnvironment();

export const isProduction = () => apiEnv && apiEnv === 'prod';

export const subscriptiongraphqlDomain = () => {
	const environmentPrefix = isProduction() ? '' : `${apiEnv}.`;
	return `https://${environmentPrefix}${subscriptionGGLHost}/graphql`;
};

const resourceLibraryGQLHost = 'graphql.resourcelibrary.api.ashcompanies.com';

export const resourceLibraryGraphqlDomain = () => {
	const environmentPrefix = isProduction() ? '' : `${apiEnv}.`;
	return `https://${environmentPrefix}${resourceLibraryGQLHost}/graphql`;
};

